<template>
  <div class="col">
    <div class="row">
      <div class="col">
        <label>Page access</label>
        <div class="custom-control custom-checkbox" :key=name v-for="(value,name) in pages">
          <input v-model="pages[name]"
                 :value="value"
                 type="checkbox"
                 :id="name"
                 class="custom-control-input">
          <label class="custom-control-label" :for="name">
            <span>{{ name }}</span>
          </label>
        </div>
      </div>
      <div class="col-2">
        <button class="btn-success btn" @click="savePagesConfig"> Save</button>
      </div>
    </div>
  </div>
</template>

<script>
const allowedPages = {
  jobs: false,
  operatorInterface: false,
  teamLead: false,
  downTimes: false,
  workflows: false,
  reasonTrees: false,
  improvements: false,
  insights: false,
  instructions:false,
  oeeAnalytics:false,
  shifts:false,
  floorPlan:false

}
export default {
  name: "PageSettings",
  props: ['selectedCompany'],
  data() {
    return {
      pages: {}
    }
  },
  methods: {
    savePagesConfig() {

      return this.$FB.collection('companies').doc(this.selectedCompany).update({pages:this.pages})
    }
  },
  watch: {
    async selectedCompany() {
      this.pages = allowedPages
      let companyConfig = await this.$FB.collection('companies').doc(this.selectedCompany).get()
      companyConfig = companyConfig.data()

      this.pages =  Object.assign({}, allowedPages)
      if (companyConfig.pages) {
        for (let key in companyConfig.pages) {
          this.pages[key] = companyConfig.pages[key]
        }
      }
    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>